import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { SystemConstants } from "../common/system.constants";
import { LoggedInUser } from "../domain/loggedin.user";
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class RestApiService {
  // Define API
  protected apiURL = SystemConstants.BASE_API;

  constructor(private http: HttpClient) {}

  /*========================================
      CRUD Methods for consuming RESTful API
    =========================================*/

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  getEndPoints(url) {
    return `${this.apiURL}${url}`;
  }

  post(url, params: any) {
    //console.log(url,params);
    const apiUrl = this.getEndPoints(url);
    console.log('url',apiUrl);
    return this.http.post(apiUrl, params, this.httpOptions).pipe(
      tap(res => {
        localStorage.removeItem(SystemConstants.CURRENT_USER);
        console.log("Inside", res);
        //localStorage.setItem("access_token", res.access_token);
        let _data:any={};
        _data.id = res["ResultObj"]["Id"];
        _data.first_name = res["ResultObj"]["FirstName"];
        _data.last_name = res["ResultObj"]["LastName"];
        _data.fullname = null;//res["ResultObj"]["fullname"];
        _data.email = res["ResultObj"]["Email"];
        _data.access_token = res["ResultObj"]["token"];
        // _data.refresh_token = res["ResultObj"]["refreshToken"]==undefined?null:res["ResultObj"]["refreshToken"];
        _data.avatar = res["ResultObj"]["Employee"]["Avatar"]==undefined?null:res["ResultObj"]["Employee"]["Avatar"];
        _data.status = res["ResultObj"]["Employee"]["WorkStatus"]==undefined?null:res["ResultObj"]["Employee"]["WorkStatus"];
        _data.roles = res["ResultObj"]["Roles"]==undefined?[]:res["ResultObj"]["Roles"];
        _data.permissions = res["ResultObj"]["Permissions"]==undefined?[]:res["ResultObj"]["Permissions"];
        _data.lang = res["ResultObj"]["Lang"];
        _data.short_code = res["ResultObj"]["Employee"]["Short_Code"]==undefined?null:res["ResultObj"]["Employee"]["Short_Code"];
        _data.username = res["ResultObj"]["UserName"];
        _data.department = res["ResultObj"]["Department"]==undefined?[]:res["ResultObj"]["Department"];
        _data.ipaddress=params.ipaddress==undefined?null:params.ipaddress;
        // console.log('First', _data);
        let user: LoggedInUser = _data; //.json();
        // console.log('After',user,user.access_token);
        //user.expires = new Date(res[".expires"]);
        // console.log(res['.expires']);
        // console.log(new Date(res['.expires']));
        // console.log(new Date());
        if (user && user.access_token) {// && user.status == 1
          console.log('Taken token')
          localStorage.setItem(
            SystemConstants.CURRENT_USER,
            JSON.stringify(user)
          );
        }
      })
    );
  }

  // get(url) {
  //   const apiUrl = this.getEndPoints(url);
  //   return this.http.get(apiUrl);
  // }

  // upload(url: string, fileToUpload: File, headers = {}) {
  //   const formData: FormData = new FormData();
  //   formData.append(fileToUpload.name, fileToUpload, fileToUpload.name);
  //   const apiUrl = this.getEndPoints(url);
  //   return this.http.post(apiUrl, formData, headers);
  // }
}
